import { GlobalContextProvider, setGlobalContext } from '@prophecy/utils/react/utilify';
import React, { createContext, useContext, useMemo } from 'react';

import { AppMetadataProviderType } from './types';

const AppMetadataContext = createContext<Omit<AppMetadataProviderType, 'globalConfig' | 'unsecuredConfig'> | undefined>(
  undefined
);

export function useAppMetadata() {
  return useContext(AppMetadataContext) as Omit<AppMetadataProviderType, 'globalConfig' | 'unsecuredConfig'>;
}

export function AppMetadataProvider({
  children,
  value
}: {
  children: React.ReactNode;
  value: AppMetadataProviderType;
}) {
  const { globalConfig, unsecuredConfig, appMetadata } = useMemo(() => {
    const { globalConfig, unsecuredConfig, ...appMetadata } = value;
    return { globalConfig, unsecuredConfig, appMetadata };
  }, [value]);

  useMemo(() => {
    setGlobalContext('globalConfig', globalConfig);
    setGlobalContext('unsecuredConfig', unsecuredConfig);
  }, [globalConfig, unsecuredConfig]);

  return (
    <AppMetadataContext.Provider value={appMetadata}>
      <GlobalContextProvider>{children}</GlobalContextProvider>
    </AppMetadataContext.Provider>
  );
}
